import React from 'react'
import { RouterProvider } from 'react-router-dom';
import { AppThemeProvider } from './AppThemeProvider';
import router from './router';
import { Provider } from 'react-redux';
import { store } from './store';
const App = () => {
  return (
    <AppThemeProvider>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>

    </AppThemeProvider>
  )
}

export default App